<ap-modal #baseModal
          [appModalId]="'project-tagging'"
          [ariaLabel]="'Project Tagging'"
          [closable]="true"
          [style]="{'width': '75rem'}"
          (onClose)="closeModal('project-tagging')">
  <ng-template ngTemplate="header">
    <div class="d-flex align-items-center">
      <h3 class="modal-title">Project Tagging</h3>
      @if (savingSelection) {
<span style="margin-left: 10px;">
        <ap-loading [loadingType]="'circular'" [indeterminate]="true" [compact]="true"></ap-loading>
      </span>
}
    </div>
  </ng-template>
  <div class="project-tagging-modal-body">
    <div style="margin-bottom: 10px;">
      <span class="a-h-12">Please select a Project, Project Step (as applicable) and Business level used for tax return review</span>
    </div>
    <div class="project-info row">
      <div class="col-md-3">
        <span class="font-weight-bold">Project</span>
      </div>
      <div class="col-md-7">
        <span class="">{{getProjectName()}}</span>
      </div>
    </div>
    <div class="project-info row">
      <div class="col-md-3">
        <span class="font-weight-bold">Project Step</span>
      </div>
      <div class="col-md-7">
        <span class="">{{getProjectStepName()}}</span>
      </div>
    </div>
    <div class="project-info row">
      <div class="col-md-3">
        <span class="font-weight-bold">Project Business</span>
      </div>
      <div class="col-md-7">
        <span class="">{{selectedBusiness?.name}}</span>
      </div>
    </div>
    <div class="trees row">
      <div class="col-md-6">
        <div class="search-collapse-row">
          <input class="search-box" style="border: 1px solid #333333;padding-left: 10px;" id="filter" #filter (keyup)="filterProjects(filter.value)" placeholder="Search Projects"/>
          <ap-button [compact]="true" [btnType]="'text'" [label]="'Collapse All'" (onClick)="collapseAllProjectTrees()"></ap-button>
        </div>
      </div>
      <div class="col-md-6">
        <div class="search-collapse-row">
          <input class="search-box" style="border: 1px solid #333333;padding-left: 10px;" id="filter1" #filter1 (keyup)="filterBusinesses(filter1.value)" placeholder="Search Businesses"/>
          <ap-button [compact]="true" [btnType]="'text'" [label]="'Collapse All'" (onClick)="collapseAllBusinessTrees()"></ap-button>
        </div>
      </div>
    </div>
    <div class="trees row">
      <div class="col-md-6">
        <div class="tree-container" role="region" aria-label="Projects">
          @if (loadingData) {
<span>
            <ap-loading [loadingType]="'circular'" [indeterminate]="true" [compact]="false"></ap-loading>
          </span>
}
          @if (!loadingData) {
<ap-tree [data]="filteredProjectsData" (onClick)="onProjectSelected($event)"></ap-tree>
}
        </div>
      </div>
      <div class="col-md-6">
        <div class="tree-container" role="region" aria-label="Businesses">
          @if (loadingData) {
<span>
            <ap-loading [loadingType]="'circular'" [indeterminate]="true" [compact]="false"></ap-loading>
          </span>
}
          @if (!loadingData) {
<ap-tree [data]="filteredBusinessesData" (onClick)="onBusinessSelected($event)"></ap-tree>
}
        </div>
      </div>
    </div>
  </div>
  <ng-template ngTemplate="footer">
    <ap-button [compact]="true" [btnType]="'primary'" [label]="'SAVE'" class="ap-mr-spacing-3" (onClick)="OkSubmit('project-tagging')"></ap-button>&nbsp;&nbsp;
    <ap-button [compact]="true" [btnType]="'secondary'" [label]="'CLOSE'" (onClick)="closeModalOk('project-tagging')"></ap-button>
  </ng-template>
</ap-modal>

